import { render, staticRenderFns } from "./BindServer.vue?vue&type=template&id=f0a5b30c&"
import script from "./BindServer.vue?vue&type=script&lang=js&"
export * from "./BindServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports